import FeedbackStars from "components/FeedbackStars/FeedbackStars";

export default FeedbackStars